import { Select } from "antd";
import { useEffect, useState } from "react";
import { Locale } from "../../../utils";
import { fetchMerchantCategories } from "../../../utils/helpers/merchantCategoryHelpers";

const { Option } = Select;
const i18n = Locale.getInstance();

export default function CategoryFilterSelect({
  user,
  value,
  onChange,
  enabled = true,
  style,
}) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !user?.token) {
      setCategories([]);
      return;
    }

    let cancelled = false;
    setLoading(true);
    fetchMerchantCategories(user)
      .then((list) => {
        if (!cancelled) {
          setCategories(list);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCategories([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, user]);

  return (
    <Select
      value={value}
      onChange={onChange}
      loading={loading}
      style={{ minWidth: 180, ...style }}
      showSearch
      optionFilterProp="children"
    >
      <Option value={-1}>{i18n.t("sales.coupons.all")}</Option>
      {categories.map((category) => (
        <Option key={category.id} value={category.id}>
          {i18n.getPropNameByLocale(category, "name")}
        </Option>
      ))}
    </Select>
  );
}
